const DEFAULT_GENRE = `All genres`;

export {DEFAULT_GENRE};
